/*
 * The Belgian Brewer: Private hire (sections/tbb-hire.liquid).
 * - Accordion: at 1100px and wider, hover, keyboard focus or a click opens a panel (the others narrow).
 *   Below 1100px every panel is open and the buttons are just headings.
 * - "Enquire" links preselect their space in the form.
 * - Spaces at the venue picked in "Venue with its own occasion choices" swap in that venue's
 *   occasion list (e.g. "Private tasting" at Epping instead of the brewery tour).
 * - Inline validation for name and email before the form posts; after a successful post the
 *   thank-you message is scrolled into view and focused.
 */
function setUpAccordion(root) {
  const accordion = root.querySelector('[data-tbb-accordion]');
  if (!accordion) return;
  const slices = [...accordion.querySelectorAll('[data-tbb-slice]')];
  if (!slices.length) return;
  const wide = window.matchMedia('(min-width: 1100px)');
  let current = accordion.querySelector('.is-open') || slices[0];

  const paint = () =>
    slices.forEach((slice) => {
      slice.classList.toggle('is-open', slice === current);
      slice.querySelector('.tbb-hire__btn')?.setAttribute('aria-expanded', String(!wide.matches || slice === current));
    });
  const open = (slice) => {
    if (slice !== current) {
      current = slice;
      paint();
    }
  };

  slices.forEach((slice) => {
    slice.addEventListener('mouseenter', () => {
      if (wide.matches) open(slice);
    });
    slice.addEventListener('focusin', () => open(slice));
    slice.addEventListener('click', () => open(slice));
  });
  wide.addEventListener('change', paint);
  paint();
}

function setUpForm(root) {
  const form = root.querySelector('form#enquire');
  const select = root.querySelector('[data-tbb-space-select]');

  root.querySelectorAll('[data-tbb-space]').forEach((link) =>
    link.addEventListener('click', () => {
      if (select && [...select.options].some((o) => o.value === link.dataset.tbbSpace)) {
        select.value = link.dataset.tbbSpace;
        select.dispatchEvent(new Event('change'));
      }
    })
  );

  const done = root.querySelector('[data-tbb-enquiry-done]');
  if (done) {
    done.scrollIntoView({ block: 'center' });
    done.focus({ preventScroll: true });
  }

  if (!form) return;
  const emailPattern = /^\S+@\S+\.\S+$/;

  form.addEventListener('submit', (event) => {
    let firstInvalid = null;
    form.querySelectorAll('[data-tbb-required]').forEach((field) => {
      const value = field.value.trim();
      const ok = field.type === 'email' ? emailPattern.test(value) : value !== '';
      const message = document.getElementById(field.getAttribute('aria-describedby'));
      field.setAttribute('aria-invalid', String(!ok));
      if (message) message.textContent = ok ? '' : field.dataset.tbbRequired;
      if (!ok && !firstInvalid) firstInvalid = field;
    });
    if (firstInvalid) {
      event.preventDefault();
      firstInvalid.focus();
    }
  });
}

function setUpOccasions(root) {
  const spaceSelect = root.querySelector('[data-tbb-space-select]');
  const occasionSelect = root.querySelector('[data-tbb-occasion-select]');
  const venueList = root.querySelector('template[data-tbb-venue-occasions]');
  if (!spaceSelect || !occasionSelect || !venueList) return;
  const lists = {
    main: [...occasionSelect.options].map((option) => option.cloneNode(true)),
    venue: [...venueList.content.querySelectorAll('option')],
  };
  let shown = 'main';

  const sync = () => {
    const wanted = spaceSelect.selectedOptions[0]?.hasAttribute('data-tbb-venue-occasions') ? 'venue' : 'main';
    if (wanted === shown) return;
    const picked = occasionSelect.value;
    const index = occasionSelect.selectedIndex;
    const options = lists[wanted].map((option) => option.cloneNode(true));
    occasionSelect.replaceChildren(...options);
    // Keep the same choice if both lists have it, otherwise the one in the same position
    const same = options.findIndex((option) => option.value === picked);
    occasionSelect.selectedIndex = same >= 0 ? same : Math.min(index, options.length - 1);
    shown = wanted;
  };

  spaceSelect.addEventListener('change', sync);
  sync();
}

function setUp(root) {
  if (root.dataset.tbbReady) return;
  root.dataset.tbbReady = 'true';
  setUpAccordion(root);
  setUpForm(root);
  setUpOccasions(root);
}

const init = (root = document) => root.querySelectorAll('[data-tbb-hire]').forEach(setUp);
init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
